import { useState } from "react";
import { toast } from "sonner";
import { MagnifyingGlass } from "@phosphor-icons/react";
import api from "@/lib/api";
import { ALL_CODES, countryName } from "@/pages/admin/CountryPicker";

const B = process.env.REACT_APP_BACKEND_URL;
const fmt = (d) => new Date(`${d}T12:00:00Z`).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" });
const todayUK = () => new Date().toLocaleDateString("en-CA", { timeZone: "Europe/London" });
const OPTIONS = [...ALL_CODES].sort((a, b) => countryName(a).localeCompare(countryName(b)));

// Admin check: which seasonal theme a visitor from a country sees on a given day.
export default function ShowingNowPanel() {
  const [cc, setCc] = useState("GB");
  const [on, setOn] = useState(todayUK());
  const [res, setRes] = useState(null);
  const check = async () => {
    try { const { data } = await api.get("/admin/seasonal-themes/showing", { params: { country: cc, on } }); setRes(data); }
    catch (e) { toast.error(e?.response?.data?.detail || "Could not check"); }
  };
  const s = res?.showing;
  return (
    <div className="card-recipe !p-5 mb-6" data-testid="seasonal-showing-panel">
      <p className="font-bold text-rf-ink mb-3">What's showing?</p>
      <div className="flex flex-wrap items-end gap-3">
        <label className="text-xs font-bold">Visitor in
          <select value={cc} onChange={(e) => setCc(e.target.value)} className="input-rf mt-1 !py-2" data-testid="seasonal-showing-country">
            {OPTIONS.map((c) => <option key={c} value={c}>{countryName(c)}</option>)}
          </select>
        </label>
        <label className="text-xs font-bold">On (UK date)
          <input type="date" value={on} onChange={(e) => setOn(e.target.value)} className="input-rf mt-1 !py-2" data-testid="seasonal-showing-date" />
        </label>
        <button type="button" onClick={check} className="btn-amber !py-2 !px-4 text-sm inline-flex items-center gap-1" data-testid="seasonal-showing-check"><MagnifyingGlass size={16} /> Check</button>
      </div>
      {res && (
        <div className="mt-4 text-sm" data-testid="seasonal-showing-result">
          {s ? (
            <div className="flex flex-wrap gap-4 items-start">
              <img src={`${B}${s.hero_url}`} alt="" className="w-56 aspect-[16/9] object-cover rounded-lg border" />
              <div>
                <p className="font-bold text-rf-ink" data-testid="seasonal-showing-name">{s.name}</p>
                <p className="text-rf-ink-soft">{fmt(s.starts_on)} – {fmt(s.ends_on)} · {s.countries.length ? `${s.countries.length} countr${s.countries.length === 1 ? "y" : "ies"}` : "worldwide"}</p>
                <a href={`/?preview_theme=${s.theme_id}`} target="_blank" rel="noopener noreferrer" className="text-rf-orange underline font-semibold text-xs">Preview on site</a>
              </div>
            </div>
          ) : <p className="font-semibold text-rf-ink" data-testid="seasonal-showing-none">No seasonal theme — {countryName(res.country)} sees the normal homepage on {fmt(res.date)}.</p>}
          {res.beaten.length > 0 && <p className="mt-3 text-rf-ink-soft" data-testid="seasonal-showing-beaten">Also running but outranked: {res.beaten.map((t) => `“${t.name}”`).join(", ")}.</p>}
          {res.drafts.length > 0 && <p className="mt-1 text-amber-700" data-testid="seasonal-showing-drafts">Not approved yet, so not showing: {res.drafts.map((t) => `“${t.name}”`).join(", ")}.</p>}
        </div>
      )}
    </div>
  );
}
